export default '/build/ef6d8084.svg'